import React, { createContext, useContext, useEffect } from 'react';

export type TabLoadingReportFn = (tabId: string, loading: boolean) => void;

const TabLoadingReporterContext = createContext<TabLoadingReportFn | null>(null);

export function TabLoadingReporterProvider({
  value,
  children,
}: {
  value: TabLoadingReportFn;
  children: React.ReactNode;
}) {
  return (
    <TabLoadingReporterContext.Provider value={value}>{children}</TabLoadingReporterContext.Provider>
  );
}

/**
 * Reports loading for a tab to the nearest TabLoadingReporterProvider.
 * Clears the flag on unmount or when `loading` becomes false.
 * When `tabId` is null or undefined, does nothing (for shared tables used with or without a detail tab).
 */
export function useNotifyTabLoading(tabId: string | null | undefined, loading: boolean): void {
  const report = useContext(TabLoadingReporterContext);
  useEffect(() => {
    if (report == null || tabId == null || tabId === '') {
      return undefined;
    }
    report(tabId, loading);
    return () => {
      report(tabId, false);
    };
  }, [report, tabId, loading]);
}
